/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FaqInterface } from '../interfaces';
import { ModelApiBase } from '../model-api.base';
import { PolpoApi } from '../polpo-api';

@Injectable({ providedIn: 'root' })
export class FaqApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Faqs');
  }

  findOne(options?): Observable<FaqInterface> {
    const path = 'findOne';

    const params = this._getHttpParams({ filter: options });

    return this.get<FaqInterface>(path, params);
  }
}
